import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { ROUTES } from "@/shared/config";
import { Button } from "@/shared/ui";

/**
 * Блок просадки. Figma: `Risk Control` (19:149) — показывается только в
 * состоянии `loss_alert`.
 *
 * Кнопка ведёт в «мои роботы», а не останавливает робота прямо отсюда:
 * останавливать надо конкретного, а в просадке их может быть несколько.
 */
export function RiskControl() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="flex w-full flex-col gap-2.5 rounded-[20px] border border-status-loss bg-background-elevated p-4">
      <h2 className="text-h3 font-semibold text-text-primary">{t("home.riskControl.title")}</h2>
      <p className="text-caption font-normal text-text-secondary">{t("home.riskControl.body")}</p>
      <Button
        size="cta"
        variant="danger"
        block
        onClick={() => {
          void navigate(ROUTES.myRobots);
        }}
      >
        {t("home.riskControl.cta")}
      </Button>
    </section>
  );
}
